import React from 'react'
import { Navigate, useParams } from 'react-router'
import { ROUTES } from 'sharedKernel/constants'
import { validate as uuidValidate } from 'uuid'
import { CaixaEmployeeRegisterForm } from '../../../../../domain/feature/hotsite/Forms/CaixaEmployeeRegister/v1'

export const HotsiteCaixaEmployeeRegisterPage = (): JSX.Element => {
  const { challengeId } = useParams()
  
  if (challengeId && !uuidValidate(challengeId)) {
    return <Navigate to={ROUTES.NOT_FOUND} />
  }

  return (
    <>
      <CaixaEmployeeRegisterForm challengeId={challengeId} />
    </>
  )
}
